import OBTDockPanel from './OBTDockPanel';
export default OBTDockPanel;
